"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const polished_1 = require("polished");
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("../Themes/styled-components"));
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  margin: 0 ${polished_1.rem(4)};
`;
const Title = styled_components_1.default.div `
  font-size: ${polished_1.rem(16)};
  color: ${({ theme }) => theme.textColor};
  opacity: 1;
  font-weight: 500;
`;
const Subtitle = styled_components_1.default.div `
  font-size: ${polished_1.rem(13)};
  color: ${({ theme }) => theme.color.fadedText};
  margin-top: ${polished_1.rem(2)};
`;
const Header = ({ children, className, subtitle }) => {
    return (react_1.default.createElement(Wrapper, { className: className },
        react_1.default.createElement(Title, null, children),
        subtitle && react_1.default.createElement(Subtitle, null, subtitle)));
};
exports.default = Header;
